@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';
@import '../../styles/deviceBreakpoints.scss';

.content {
  display: flex;
  align-items: flex-end;
  gap: 1em;
  width: 50%;

  @include target(md) {
    width: 100%;
  }

  .institusjonsnr {
    display: inline-block;
    min-width: 4ch;
  }

  .navn {
    @include barlowMedium(16);
    display: inline-block;
    color: _palette(secondary);
  }

  .submitBtn {
    margin-bottom: 0.1em;
  }
}
